var map = {
	"./MICROBIUM.png": 4073,
	"./MICROBIUM.svg": 9502,
	"./about-image.png": 7951,
	"./back.svg": 4656,
	"./background.jpg": 5322,
	"./catalog-promo/promo1000.jpg": 8368,
	"./catalog-promo/promo1176.jpg": 8334,
	"./catalog-promo/promo1560.jpg": 9555,
	"./catalog-promo/promo265.jpg": 1054,
	"./catalog-promo/promo455.jpg": 6257,
	"./catalog-promo/promo496.jpg": 1906,
	"./close-black.svg": 6801,
	"./donate-banner-mobile.png": 57,
	"./donate-banner.png": 8112,
	"./exclamation.svg": 120,
	"./favicon-1.ico": 9768,
	"./favicon-2.ico": 3723,
	"./favicon.ico": 6498,
	"./favicon.png": 6140,
	"./favicon.svg": 3339,
	"./footer-logo.svg": 508,
	"./icons/dzen.svg": 8459,
	"./icons/ok.svg": 5134,
	"./icons/search-icon-bold.svg": 8810,
	"./icons/search-icon.svg": 2334,
	"./icons/telegram.svg": 913,
	"./icons/vk.svg": 9561,
	"./logo-2.png": 3258,
	"./logo-home.png": 8339,
	"./logo-microbius-1.png": 4345,
	"./logo.svg": 3208,
	"./manifest/microbius-120.png": 6727,
	"./manifest/microbius-128.png": 2687,
	"./manifest/microbius-144.png": 8881,
	"./manifest/microbius-152.png": 8072,
	"./manifest/microbius-180.png": 7721,
	"./manifest/microbius-192.png": 396,
	"./manifest/microbius-384.png": 6895,
	"./manifest/microbius-512.png": 9096,
	"./manifest/microbius-72.png": 3957,
	"./manifest/microbius-96.png": 635,
	"./marketing-banner/arrow.svg": 1920,
	"./marketing-banner/installation-1-mob.png": 4537,
	"./marketing-banner/installation-1.png": 3604,
	"./marketing-banner/installation-2.png": 6063,
	"./marketing-banner/installation-3.png": 966,
	"./marketing-banner/logo.png": 3371,
	"./marketing-banner/marketing-banner-bg.jpg": 2645,
	"./microbius-comments-logo.png": 5854,
	"./microbius-logo-footer-ru.png": 9761,
	"./microbius-logo-min-ru.png": 2624,
	"./microbius-logo-mini-ng.png": 5851,
	"./microbius-logo-ng.png": 6307,
	"./microbius-logo.png": 8735,
	"./next.svg": 7042,
	"./share/copy.svg": 2262,
	"./share/dzen.svg": 78,
	"./share/email.svg": 2251,
	"./share/ok.svg": 5879,
	"./share/telegram.svg": 5316,
	"./share/vk.svg": 2268,
	"./share/whatsapp.svg": 6591,
	"./umoney.svg": 6562,
	"./vk-pay.svg": 4453,
	"images/MICROBIUM.png": 4073,
	"images/MICROBIUM.svg": 9502,
	"images/about-image.png": 7951,
	"images/back.svg": 4656,
	"images/background.jpg": 5322,
	"images/catalog-promo/promo1000.jpg": 8368,
	"images/catalog-promo/promo1176.jpg": 8334,
	"images/catalog-promo/promo1560.jpg": 9555,
	"images/catalog-promo/promo265.jpg": 1054,
	"images/catalog-promo/promo455.jpg": 6257,
	"images/catalog-promo/promo496.jpg": 1906,
	"images/close-black.svg": 6801,
	"images/donate-banner-mobile.png": 57,
	"images/donate-banner.png": 8112,
	"images/exclamation.svg": 120,
	"images/favicon-1.ico": 9768,
	"images/favicon-2.ico": 3723,
	"images/favicon.ico": 6498,
	"images/favicon.png": 6140,
	"images/favicon.svg": 3339,
	"images/footer-logo.svg": 508,
	"images/icons/dzen.svg": 8459,
	"images/icons/ok.svg": 5134,
	"images/icons/search-icon-bold.svg": 8810,
	"images/icons/search-icon.svg": 2334,
	"images/icons/telegram.svg": 913,
	"images/icons/vk.svg": 9561,
	"images/logo-2.png": 3258,
	"images/logo-home.png": 8339,
	"images/logo-microbius-1.png": 4345,
	"images/logo.svg": 3208,
	"images/manifest/microbius-120.png": 6727,
	"images/manifest/microbius-128.png": 2687,
	"images/manifest/microbius-144.png": 8881,
	"images/manifest/microbius-152.png": 8072,
	"images/manifest/microbius-180.png": 7721,
	"images/manifest/microbius-192.png": 396,
	"images/manifest/microbius-384.png": 6895,
	"images/manifest/microbius-512.png": 9096,
	"images/manifest/microbius-72.png": 3957,
	"images/manifest/microbius-96.png": 635,
	"images/marketing-banner/arrow.svg": 1920,
	"images/marketing-banner/installation-1-mob.png": 4537,
	"images/marketing-banner/installation-1.png": 3604,
	"images/marketing-banner/installation-2.png": 6063,
	"images/marketing-banner/installation-3.png": 966,
	"images/marketing-banner/logo.png": 3371,
	"images/marketing-banner/marketing-banner-bg.jpg": 2645,
	"images/microbius-comments-logo.png": 5854,
	"images/microbius-logo-footer-ru.png": 9761,
	"images/microbius-logo-min-ru.png": 2624,
	"images/microbius-logo-mini-ng.png": 5851,
	"images/microbius-logo-ng.png": 6307,
	"images/microbius-logo.png": 8735,
	"images/next.svg": 7042,
	"images/share/copy.svg": 2262,
	"images/share/dzen.svg": 78,
	"images/share/email.svg": 2251,
	"images/share/ok.svg": 5879,
	"images/share/telegram.svg": 5316,
	"images/share/vk.svg": 2268,
	"images/share/whatsapp.svg": 6591,
	"images/umoney.svg": 6562,
	"images/vk-pay.svg": 4453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4721;